export default __webpack_public_path__ + "static/media/keto_hydration@3x.793d6dcf.jpg";